import React from 'react';
import { ChevronRight, Home, Folder } from 'lucide-react';
import { Folder as FolderType } from '../../types';

interface FolderBreadcrumbProps {
  folderPath: FolderType[];
  onNavigateToFolder: (folderId?: string) => void;
}

export const FolderBreadcrumb: React.FC<FolderBreadcrumbProps> = ({
  folderPath,
  onNavigateToFolder,
}) => {
  return (
    <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 mb-4">
      <button
        onClick={() => onNavigateToFolder(undefined)}
        className="flex items-center hover:text-fire-600 dark:hover:text-fire-400 transition-colors duration-200"
      >
        <Home className="h-4 w-4 mr-1" />
        All Prompts
      </button>
      
      {folderPath.map((folder, index) => (
        <React.Fragment key={folder.id}>
          <ChevronRight className="h-4 w-4 text-gray-400 dark:text-gray-500" />
          <button
            onClick={() => onNavigateToFolder(folder.id)}
            className="flex items-center hover:text-fire-600 dark:hover:text-fire-400 transition-colors duration-200"
          >
            <Folder 
              className="h-4 w-4 mr-1" 
              style={{ color: folder.color }}
            />
            {folder.name}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};